module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxc-index-list",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [_c('list', {
    staticClass: "index-list",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle({
      height: _vm.height + 'px'
    }))
  }, _vm._l((_vm.formatList), function(v, i) {
    return _c('cell', {
      key: i,
      ref: 'index-item-title-' + v.title,
      refInFor: true,
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [(!_vm.onlyShowList) ? _c('text', {
      class: ['index-list-title', v.type && v.type == 'group' && 'group-title'],
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, [_vm._v(_vm._s(v.title))]) : _vm._e(), _vm._v(" "), (v.type && v.type == 'group' && !_vm.onlyShowList) ? _c('div', {
      staticClass: "group",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined))
    }, _vm._l((v.data), function(group, index) {
      return _c('div', {
        key: index,
        staticClass: "group-list",
        staticStyle: _vm.$processStyle(undefined),
        style: (_vm.$processStyle(undefined))
      }, _vm._l((group), function(item, i) {
        return _c('div', {
          key: i,
          staticClass: "group-item",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined)),
          on: {
            "click": function($event) {
              _vm.itemClicked(item)
            }
          }
        }, [(item.isLocation) ? _c('image', {
          staticClass: "location-icon",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined)),
          attrs: {
            "src": "//gw.alicdn.com/tfs/TB1JUiUPFXXXXXUXXXXXXXXXXXX-32-32.png"
          }
        }) : _vm._e(), _vm._v(" "), _c('div', {
          staticClass: "item-content",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_c('text', {
          staticClass: "item-name",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.desc) ? _c('text', {
          staticClass: "item-desc",
          staticStyle: _vm.$processStyle(undefined),
          style: (_vm.$processStyle(undefined))
        }, [_vm._v(_vm._s(item.desc))]) : _vm._e()])])
      }))
    })) : _vm._e(), _vm._v(" "), (v.type === 'list') ? _c('div', _vm._l((v.data), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "index-list-item",
        staticStyle: _vm.$processStyle(undefined),
        style: (_vm.$processStyle(undefined)),
        on: {
          "click": function($event) {
            _vm.itemClicked(item)
          }
        }
      }, [_c('text', {
        staticClass: "title",
        staticStyle: _vm.$processStyle(undefined),
        style: (_vm.$processStyle(undefined))
      }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('text', {
        staticClass: "desc",
        staticStyle: _vm.$processStyle(undefined),
        style: (_vm.$processStyle(undefined))
      }, [_vm._v(_vm._s(item.desc))])])
    })) : _vm._e()])
  })), _vm._v(" "), (_vm.showIndex && !_vm.onlyShowList) ? _c('div', {
    staticClass: "index-list-nav",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(_vm.navStyle))
  }, _vm._l((_vm.formatList), function(item, index) {
    return _c('text', {
      key: index,
      staticClass: "list-nav-key",
      staticStyle: _vm.$processStyle(undefined),
      style: (_vm.$processStyle(undefined)),
      attrs: {
        "title": item.title
      },
      on: {
        "click": function($event) {
          _vm.go2Key(item.title)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  })) : _vm._e(), _vm._v(" "), (_vm.popKeyShow) ? _c('div', {
    staticClass: "index-list-pop",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [_c('text', {
    staticClass: "list-pop-text",
    staticStyle: _vm.$processStyle(undefined),
    style: (_vm.$processStyle(undefined))
  }, [_vm._v(_vm._s(_vm.popKey))])]) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-8a0583fa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a0583fa"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/wxc-indexlist/index.vue
// module id = 82
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28